module.exports = __webpack_public_path__ + "static/media/Gaurav's Resume.ce9f8e02.pdf";